import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

// Define available languages
export const LANGUAGES = {
  en: { nativeName: 'English', name: 'English' },
  fr: { nativeName: 'Français', name: 'French' },
  nl: { nativeName: 'Nederlands', name: 'Dutch' },
};

// Storage key for language preference
export const LANGUAGE_STORAGE_KEY = 'budget_app_language';

// Initialize i18next
i18n
  // Use dynamic imports for loading translation files
  .use(
    resourcesToBackend(
      (language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)
    )
  )
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: 'en',
    // Debug mode in development (disabled during tests)
    debug: import.meta.env.MODE !== 'test' && import.meta.env.DEV,
    // Language detection options
    detection: {
      // Order of detection
      order: ['localStorage', 'navigator'],
      // Cache language in localStorage
      caches: ['localStorage'],
      // Local storage key
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    // Interpolation configuration
    interpolation: {
      // React already escapes values
      escapeValue: false,
    },
  });

// Function to change language and save to localStorage
export const changeLanguage = (language: string) => {
  i18n.changeLanguage(language);
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  // If there's a cloud sync in the future, you can add code here to sync with cloud
};

// Function to get current language
export const getCurrentLanguage = () => {
  return i18n.language || localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en';
};

export default i18n;
